import React, { Component } from 'react';

// Component Imports
import ActivityItem from './ModalListItems/ActivityItem';
import CloseButton from './CloseButton';

require('./Modal.scss');

class ActivityModal extends Component {
    render() {
        let compare = function(a,b) {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
        };
        var activities = this.props.content.sort(compare);
        var close = this.props.closeModal;
        let activitiesList = activities.map((activity, i) => {
            return (
                <ActivityItem
                    key={'activityItem'+i}
                    category={activity}
                    buttonStyle="btn-submit"
                    closeModal={ close }
                    />
            );
        });
        return (
            <div className="modalPanel searchListModal">
                <button className="close" onClick={ this.props.closeModal }>
                    <CloseButton />
                </button>
                <div className="modalWrap">
                    <div className="modalHeader text-center">
                        <h4>Select Your Activity/Category</h4>
                    </div>
                    <div className="modalContent">
                        <div className="searchSelectList">
                            <div className="searchListResultWrapper">

                        <div className="container-fluid">
                            { activitiesList }
                        </div>
                        </div></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ActivityModal;



// WEBPACK FOOTER //
// ./app/components/Modals/ActivityModal.jsx